'use client'

import Script from 'next/script'

import { useConsentPolicy } from '../../../_providers/ConsentPolicyProvider.client'

export const SienaChatScript = ({
  shiftWidgetUpMobile = false,
}: {
  shiftWidgetUpMobile?: boolean
}) => {
  const sienaChatKey = process.env.NEXT_PUBLIC_SIENA_CHAT_KEY
  const {
    consentPolicy: { functional },
  } = useConsentPolicy()

  if (functional !== 'allowed' || !sienaChatKey) return null

  return (
    <Script
      id='siena-chat-script'
      strategy='lazyOnload'
      src={`https://chat.siena.cx/dist/webchat.js?appKey=${sienaChatKey}`}
      onLoad={
        shiftWidgetUpMobile
          ? () => {
              const style = document.createElement('style')
              style.id = 'siena-css-overrides'
              style.innerHTML = `
          .siena-iframe {
            bottom: 72px !important;
          }
        `
              document.head.appendChild(style)
            }
          : undefined
      }
    />
  )
}
